import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import PropTypes from "prop-types";

const LookupTableFooter = ({ rows, alterTable }) => {
  if (!rows || rows.length === 0) {
    return null;
  }
  const columnCount = rows[0].length;

  return (
    <TableRow id="alter-table-row">
      <TableCell colSpan={columnCount}>
        <Box className="lookup-table-edit-buttons">
          <Button className="siteBlue" onClick={() => alterTable("add row")}>
            add row
          </Button>
          <Button className="siteBlue" onClick={() => alterTable("delete row")}>
            delete row
          </Button>
          <Button className="siteBlue" onClick={() => alterTable("add column")}>
            add column
          </Button>
          <Button
            className="siteBlue"
            onClick={() => alterTable("delete column")}
          >
            delete column
          </Button>
        </Box>
      </TableCell>
    </TableRow>
  );
};

LookupTableFooter.propTypes = {
  rows: PropTypes.array,
  alterTable: PropTypes.func,
};

export default LookupTableFooter;
